import Link from 'next/link';

import IconButton from '@/components/common/IconButton';

// interface OpenStoreProps {
//   dictionary?: {
//     buttons: Record<string, string>;
//   };
// }

const OpenStore = () => {
  return (
    <Link href="/#download" className="w-full sm:w-auto">
      <IconButton
        // dictionary={dictionary}
        label="Dùng thử miễn phí"
        variant="primary"
        className="button-shinny w-full sm:w-auto"
      />
    </Link>
  );
};

export default OpenStore;
